import { Close } from '@mui/icons-material';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react'
import ChefForPartyService from '../../services/ChefForPartyService';
import AppConstantService from '../../services/AppConstantService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { colors } from '../../styles/colors';



interface InputProps {
    data: any;
    open: boolean;
    callBack: () => void;
}


let chefForPartyService = new ChefForPartyService();
let appConstantService = new AppConstantService();

const DEFAULT_FOOD_PREFERENCE_OPTIONS = [
    'No Onion & Garlic (Jain Food)',
    'Less Spicy',
    'Medium Spicy',
    'Extra Spicy',
];

const FOOD_PREFERENCE_LABEL = 'Select Food Preferences';

const getInitialFoodPreferences = (data: any) => {
    if (Array.isArray(data?.foodPreferences)) {
        return data.foodPreferences.filter(Boolean);
    }

    if (data?.foodPreferences && typeof data.foodPreferences === 'object') {
        return Object.values(data.foodPreferences).filter(Boolean);
    }

    if (typeof data?.foodPreferences === 'string' && data.foodPreferences.trim()) {
        return [data.foodPreferences];
    }

    return [];
};

function AddPartyPreferencesDialog(props: InputProps) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const palette = isDarkMode ? colors.dark : colors.light;
    const initialFoodPreferences = getInitialFoodPreferences(props?.data);
    let[partyPreferences,setPartyPreferences] = useState<any>({
        numberOfBurners: props?.data?.numberOfBurners || 0,
        vegOnlyPeople: props?.data?.vegOnlyPeople || 0,
        foodPreferences: initialFoodPreferences,
    });
    const [foodPreferenceOptions, setFoodPreferenceOptions] = useState<string[]>(DEFAULT_FOOD_PREFERENCE_OPTIONS);
    const [foodPreferenceOpen, setFoodPreferenceOpen] = useState(false);
    const [draftFoodPreferences, setDraftFoodPreferences] = useState<string[]>(initialFoodPreferences);

    useEffect(() => {
        appConstantService.fetchAllAppConstants(10, 0, { name: 'PARTY_FOOD_PREFERENCES' }, {}).then((response: any) => {
            console.log("response of app constant", response)
            const appConstant = response?.data?.find((item: any) => item?.name === 'PARTY_FOOD_PREFERENCES');
            const rawValue = appConstant?.value;
            console.log("sanitizedOptions....", rawValue)

            if (!rawValue) {
                return;
            }

            let parsedValue = rawValue;

            if (typeof rawValue === 'string') {
                try {
                    parsedValue = JSON.parse(rawValue);
                } catch (error) {
                    parsedValue = rawValue;
                }
            }

            if (Array.isArray(parsedValue)) {
                const sanitizedOptions = parsedValue.filter((item) => typeof item === 'string' && item.trim());
                console.log("sanitizedOptions", sanitizedOptions)

                if (sanitizedOptions.length) {
                    setFoodPreferenceOptions(sanitizedOptions);
                }
            }
        }).catch((error: any) => {
            console.error('Error fetching FOOD_PREFERENCE_OPTIONS app constant:', error);
        });
    }, []);

    console.log("foodPreferenceOptions", foodPreferenceOptions)

    const handleClose = () => {
        props.callBack();
    };

    const handleFoodPreferenceOpen = () => {
        setDraftFoodPreferences(partyPreferences.foodPreferences);
        setFoodPreferenceOpen(true);
    };

    const handleFoodPreferenceCancel = () => {
        setDraftFoodPreferences(partyPreferences.foodPreferences);
        setFoodPreferenceOpen(false);
    };

    const handleFoodPreferenceDone = () => {
        setPartyPreferences({
            ...partyPreferences,
            foodPreferences: draftFoodPreferences,
        });
        setFoodPreferenceOpen(false);
    };

    const handleSubmit = () => {
        const payload:any  = {};
        if(partyPreferences.numberOfBurners) {
            payload['numberOfBurners'] = partyPreferences.numberOfBurners;
        }
        if(partyPreferences.vegOnlyPeople) {
            payload['vegOnlyPeople'] = partyPreferences.vegOnlyPeople;
        }
        if(partyPreferences.foodPreferences.length) {
            payload['foodPreferences'] = partyPreferences.foodPreferences;
        }
        if(Object.keys(payload).length === 0) {
            return;
        }

        chefForPartyService.updatePartyPreferences(props?.data?.id, payload).then(() => {
            props.callBack();
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Party Preferences Updated Successfully`,
                type: CustomSnackbarTypes.SUCCESS,
            });
            setPartyPreferences({
                numberOfBurners: 0,
                vegOnlyPeople: 0,
                foodPreferences: [],
            });
            window.location.reload();
        }).catch((err) => {
            console.error(err);
            setPartyPreferences({
                numberOfBurners: 0,
                vegOnlyPeople: 0,
                foodPreferences: [],
            });
            props.callBack();
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Failed to update party preferences`,
                type: CustomSnackbarTypes.ERROR,
            });
        });
    }


  return (
    <Dialog
        onClose={handleClose}
        open={props.open}
        scroll={"paper"}
        maxWidth={false}
        PaperProps={{
            sx: {
                width: '560px',
                maxWidth: 'calc(100vw - 32px)',
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: palette.bgWhite,
            },
        }}
    >
            <DialogTitle
                sx={{
                    px: 3,
                    py: 2,
                    borderBottom: `1px solid ${palette.borderPrimary}`,
                    fontSize: '18px',
                    fontWeight: 600,
                }}
            >
                Update Party Preferences
              <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 14,
                        right: 14,
                        '&:hover': {
                            backgroundColor: palette.bgButtonlight,
                        },
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                    <FormControl fullWidth sx={{ gap: 2 }}>
                    <TextField
                        label="No. of Burners"
                        type="number"
                        variant="outlined"
                        onChange={(e) => setPartyPreferences({ ...partyPreferences, numberOfBurners: Number(e.target.value) })}
                        value={partyPreferences.numberOfBurners}
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                backgroundColor: palette.bgInputField,
                                minHeight: '56px',
                            },
                        }}
                    />
                    <TextField
                        label="Veg-Only People Count"
                        type="number"
                        variant="outlined"
                        onChange={(e) => setPartyPreferences({ ...partyPreferences, vegOnlyPeople: Number(e.target.value) })}
                        value={partyPreferences.vegOnlyPeople}
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                backgroundColor: palette.bgInputField,
                                minHeight: '56px',
                            },
                        }}
                    />
                    <FormControl fullWidth sx={{ minWidth: 0 }}>
                        <InputLabel
                            id="food-preferences-select-label"
                            shrink
                            sx={{
                                backgroundColor: palette.bgWhite,
                                px: 0.5,
                            }}
                        >
                            {FOOD_PREFERENCE_LABEL}
                        </InputLabel>
                        <Select
                            labelId="food-preferences-select-label"
                            multiple
                            open={foodPreferenceOpen}
                            onOpen={handleFoodPreferenceOpen}
                            onClose={handleFoodPreferenceCancel}
                            value={foodPreferenceOpen ? draftFoodPreferences : partyPreferences.foodPreferences}
                            onChange={(e) => setDraftFoodPreferences(e.target.value as string[])}
                            input={<OutlinedInput label={FOOD_PREFERENCE_LABEL} notched />}
                            displayEmpty
                            renderValue={(selected) => (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                        minWidth: 0,
                                        overflow: 'hidden',
                                        color: (selected as string[]).length ? palette.textSecondary : palette.textGrey,
                                        fontSize: '14px',
                                    }}
                                >
                                    {(selected as string[]).length
                                        ? `${(selected as string[]).length} selected`
                                        : 'Select food preferences'}
                                </Box>
                            )}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        mt: 1,
                                        borderRadius: '12px',
                                        maxHeight: '360px',
                                    },
                                },
                            }}
                            sx={{
                                borderRadius: '10px',
                                backgroundColor: palette.bgInputField,
                                '& .MuiSelect-select': {
                                    minHeight: '56px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxSizing: 'border-box',
                                    py: '16.5px',
                                },
                            }}
                        >
                            {foodPreferenceOptions.map((option) => (
                                <MenuItem
                                    key={option}
                                    value={option}
                                    sx={{ py: 1.25 }}
                                >
                                    <Checkbox checked={draftFoodPreferences.includes(option)} />
                                    <ListItemText primary={option} />
                                </MenuItem>
                            ))}
                            <Divider />
                            <Box
                                sx={{
                                    position: 'sticky',
                                    bottom: 0,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 1,
                                    p: 1.5,
                                    backgroundColor: palette.bgWhite,
                                    borderTop: `1px solid ${palette.borderPrimary}`,
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={handleFoodPreferenceCancel}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleFoodPreferenceDone}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        boxShadow: 'none',
                                        backgroundColor: colors.primary,
                                        '&:hover': {
                                            backgroundColor: colors.primaryDark,
                                            boxShadow: 'none',
                                        },
                                    }}
                                >
                                    Done
                                </Button>
                            </Box>
                        </Select>
                    </FormControl>
                </FormControl>
            </DialogContent>
            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    borderTop: `1px solid ${palette.borderPrimary}`,
                    backgroundColor: palette.bgWhite,
                    justifyContent: 'flex-end',
                    gap: 1.5,
                }}
            >
                <Button
                    variant="outlined"
                    onClick={() => { handleClose(); }}
                    size={"large"}
                    sx={{
                        textTransform: 'none',
                        borderRadius: '10px',
                        px: 2.5,
                        borderColor: palette.borderSecondary,
                        color: palette.textSecondary,
                    }} >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    size={"large"}
                    sx={{
                        textTransform: 'none',
                        borderRadius: '10px',
                        px: 2.5,
                        boxShadow: 'none',
                        backgroundColor: colors.primary,
                        '&:hover': {
                            backgroundColor: colors.primaryDark,
                            boxShadow: 'none',
                        },
                    }}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
  )
}
export default AddPartyPreferencesDialog
